import { render, staticRenderFns } from "./DeductingActivities.vue?vue&type=template&id=2d4ff0e4&"
import script from "./DeductingActivities.vue?vue&type=script&lang=js&"
export * from "./DeductingActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports